/**
 * คู่มือผลของแต่ละ Add-on ว่ามีผลที่เมนู/หน้าจอไหนบ้าง
 * ใช้แสดงใน Clinic Management > Add-on เป็น manual guide
 */
export const ADDON_GUIDE_KEY = 'CLINIC_MANAGEMENT.ADDON_GUIDE'

/** รายการ locale key ของผลที่มีต่อระบบ (แสดงเป็น list ใต้ชื่อ addon) */
export const ADDON_IMPACT_BY_KEY: Record<string, string[]> = {
  BRANCH_PAGE_LAYER: [
    'CLINIC_MANAGEMENT.ADDON_GUIDE.BRANCH_PAGE_LAYER.1',
    'CLINIC_MANAGEMENT.ADDON_GUIDE.BRANCH_PAGE_LAYER.2',
    'CLINIC_MANAGEMENT.ADDON_GUIDE.BRANCH_PAGE_LAYER.3'
  ],
  PRICE_RANGE: [
    'CLINIC_MANAGEMENT.ADDON_GUIDE.PRICE_RANGE.1',
    'CLINIC_MANAGEMENT.ADDON_GUIDE.PRICE_RANGE.2',
    'CLINIC_MANAGEMENT.ADDON_GUIDE.PRICE_RANGE.3',
    'CLINIC_MANAGEMENT.ADDON_GUIDE.PRICE_RANGE.4'
  ],
  DCC: [
    'CLINIC_MANAGEMENT.ADDON_GUIDE.DCC.1',
    'CLINIC_MANAGEMENT.ADDON_GUIDE.DCC.2',
    'CLINIC_MANAGEMENT.ADDON_GUIDE.DCC.3',
    'CLINIC_MANAGEMENT.ADDON_GUIDE.DCC.4',
    'CLINIC_MANAGEMENT.ADDON_GUIDE.DCC.5'
  ],
  REQUIRE_FINANCE_ACKNOWLEDGE: [
    'CLINIC_MANAGEMENT.ADDON_GUIDE.REQUIRE_FINANCE_ACKNOWLEDGE.1',
    'CLINIC_MANAGEMENT.ADDON_GUIDE.REQUIRE_FINANCE_ACKNOWLEDGE.2'
  ],
  NEW_OLD_PATIENT: [
    'CLINIC_MANAGEMENT.ADDON_GUIDE.NEW_OLD_PATIENT.1',
    'CLINIC_MANAGEMENT.ADDON_GUIDE.NEW_OLD_PATIENT.2'
  ],
  ALERT_NO_TREATMENT: [
    'CLINIC_MANAGEMENT.ADDON_GUIDE.ALERT_NO_TREATMENT.1',
    'CLINIC_MANAGEMENT.ADDON_GUIDE.ALERT_NO_TREATMENT.2'
  ],
  ALERT_NO_MEDICINE: [
    'CLINIC_MANAGEMENT.ADDON_GUIDE.ALERT_NO_MEDICINE.1',
    'CLINIC_MANAGEMENT.ADDON_GUIDE.ALERT_NO_MEDICINE.2'
  ],
  ALERT_TEETH_BEFORE_PAYMENT: [
    'CLINIC_MANAGEMENT.ADDON_GUIDE.ALERT_TEETH_BEFORE_PAYMENT.1',
    'CLINIC_MANAGEMENT.ADDON_GUIDE.ALERT_TEETH_BEFORE_PAYMENT.2'
  ],
  TREATMENT_FEE_STATEMENT: [
    'CLINIC_MANAGEMENT.ADDON_GUIDE.TREATMENT_FEE_STATEMENT.1',
    'CLINIC_MANAGEMENT.ADDON_GUIDE.TREATMENT_FEE_STATEMENT.2',
    'CLINIC_MANAGEMENT.ADDON_GUIDE.TREATMENT_FEE_STATEMENT.3'
  ]
}
